const WALLET_CONFIG = {
  WALLET_PASS: '1234',
  WALLET_NAME: 'wallet1',
  NUMMBER_OF_ACCOUNT: 1,
}

export default WALLET_CONFIG
